import { Box } from "@mui/material";
import "./NoRecordFound.css";
export default function NoRecordFounds({ text = true }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: 2 }}>
      <div class="infocard-content $spacing-p04 flex flex-col items-center">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <g id="Vector">
            <path
              d="M30 9H36L28 1L20 9H26V17.34L30 21.34V9Z"
              fill="#3A3A3A"
            ></path>
            <path
              d="M3.62003 0.619141L0.780029 3.43914L14 16.6591V29.0191L8.00003 29.0391L16 36.9991L24 28.9991L18 29.0191V20.6591L37.56 40.2191L40.38 37.3791L3.62003 0.619141Z"
              fill="currentColor"
            ></path>
          </g>
        </svg>
        <span class="font font-typography $color-text-primary $font-heading-h6-bold">
          No data found!
        </span>
        {text && (
          <span class="font font-typography $color-text-primary $font-small-regular $color-text-secondary">
            Please try a different filter value
          </span>
        )}
      </div>
    </Box>
  );
}
